import type { FunctionComponent, SVGProps } from "react"

import lifeLineBg from "@/assets/img/palmistry/result/lifeLineBgImage.webp"
import lifeLineSummaryBg from "@/assets/img/palmistry/result/lifeLineSummaryBgImage.webp"
import headLineBg from "@/assets/img/palmistry/result/headLineBgImage.webp"
import headLineSummaryBg from "@/assets/img/palmistry/result/headLineSummaryBgImage.webp"
import heartLineBg from "@/assets/img/palmistry/result/heartLineBgImage.webp"
import heartLineSummaryBg from "@/assets/img/palmistry/result/heartLineSummaryBgImage.webp"
import specialMarksBg from "@/assets/img/palmistry/result/specialMarksBgImage.webp"
import specialMarksSummaryBg from "@/assets/img/palmistry/result/specialMarksSummaryBgImage.webp"

import Hand3 from "@/assets/svg/palmistry/result/hand3.svg?react"
import Hand4 from "@/assets/svg/palmistry/result/hand4.svg?react"
import Hand5 from "@/assets/svg/palmistry/result/hand5.svg?react"
import Hand6 from "@/assets/svg/palmistry/result/hand6.svg?react"

import type { ChartType } from "./copy"
import type { PalmLineKey, ThingsKey } from "../types"

type SvgComponent = FunctionComponent<SVGProps<SVGSVGElement>>

export interface PalmLineSectionConfig {
  title: string
  subtitle: string
  sectionName: string
  summaryTypeText: string
  summaryTitle: string
  bgImage: string
  summaryBgImage: string
  HandIcon: SvgComponent
  chartType: ChartType
  /** Static palm-line copy slice (uses the matching `${lineKey}Id`). */
  lineKey: PalmLineKey
  /** Things-that-matter slice + its score, keyed on the user's reading. */
  thingsKey: ThingsKey
}

/** The four palm-line blocks rendered in order. Ported from ResultPalmReadingV4. */
export const palmLineSections: PalmLineSectionConfig[] = [
  {
    title: "Your\nLife Line",
    subtitle:
      "Reveals your energy, vitality, and major life changes—it's not about lifespan, but how fully you live.",
    sectionName: "Life Line",
    summaryTypeText: "Health Summary",
    summaryTitle: "Sculpting Inner Strength",
    bgImage: lifeLineBg,
    summaryBgImage: lifeLineSummaryBg,
    HandIcon: Hand3,
    chartType: "health",
    lineKey: "lifeLine",
    thingsKey: "health",
  },
  {
    title: "Your\nHead Line",
    subtitle:
      "Reflects your mind—how you think, learn, and make decisions. It shows your intellect and mental strengths.",
    sectionName: "Head Line",
    summaryTypeText: "Success Summary",
    summaryTitle: "Thriving in Work and Life",
    bgImage: headLineBg,
    summaryBgImage: headLineSummaryBg,
    HandIcon: Hand4,
    chartType: "success",
    lineKey: "headLine",
    thingsKey: "success",
  },
  {
    title: "Your\nHeart Line",
    subtitle: "Reveals your emotions, relationships, and how you love and connect with others.",
    sectionName: "Heart Line",
    summaryTypeText: "Romance Summary",
    summaryTitle: "Love, Loyalty, and Longing",
    bgImage: heartLineBg,
    summaryBgImage: heartLineSummaryBg,
    HandIcon: Hand5,
    chartType: "romance",
    lineKey: "heartLine",
    thingsKey: "relationship",
  },
  {
    title: "Special\nMarks",
    subtitle:
      "Unique signs on your palm that reveal hidden strengths, challenges, and turning points in your life.",
    sectionName: "Special Marks",
    summaryTypeText: "Career Summary",
    summaryTitle: "Rising Through Change",
    bgImage: specialMarksBg,
    summaryBgImage: specialMarksSummaryBg,
    HandIcon: Hand6,
    chartType: "career",
    lineKey: "specialMarks",
    thingsKey: "career",
  },
]
